import { Component, OnInit } from '@angular/core';
import { FingerSelectionHelperService } from '../finger-selection/finger-selection-helper.service';
import { AppUI, FingerSDK, LocalizationMessage, SdkOptionsType, Template, TransactionMode } from '@identy/identy-finger';
import { ContextMenuHelperService } from '../title-bar/title-context-menu/context-menu-helper.service';
import { ajax } from 'jquery';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TransactionCompleteDialog } from './dialog_renderer';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgressDialog } from './progress_dialog_renderer';
import { ZipModule } from '../../../modules/zip-module';
import { saveAs } from 'file-saver';
import { FingerSelectionComponent } from '../finger-selection/finger-selection.component';
import { StorageService } from '../../../services/storage.service';
import { BidService } from '../../../services/bid.service';
import { AlertService } from '../../../services/alert.service';
import { AlertController, LoadingController } from '@ionic/angular';
import { environment } from '../../../../environments/environment';
import { Base64 } from '@identy/identy-face';
import { BaseComponent } from 'src/app/base/base.component';
import { AuthService } from 'src/app/guards/auth.service';
import { PagesToNavigateService } from 'src/app/base/pages.service';

@Component({
  selector: 'app-sdk-run',
  templateUrl: './sdk-run.component.html',
  styleUrls: ['./sdk-run.component.css']
})
export class SdkRunComponent extends BaseComponent implements OnInit {
  urlIdentify = environment.urlIdentify;
  data: any[];
  id: any;
  action: string;
  callbackURL: string;
  bsModalTxnRef: BsModalRef;
  bsModelFrmRef: BsModalRef;
  coppelRoute: boolean;
  enrollPage;
  operationId;
  login: boolean;
  speaker;
  type;
  speakerAgent;
  ventaAsiMismo: boolean;
  countFinger;

  constructor(
    private fingerSelectionComponent: FingerSelectionComponent,
    private fingerSelectionHelper: FingerSelectionHelperService,
    private contextMenuSelection: ContextMenuHelperService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    protected router: Router,
    private storage: StorageService,
    private bidService: BidService,
    private alertService: AlertService,
    protected storageService: StorageService,
    protected loadingController: LoadingController,
    protected alertController: AlertController,
    protected authService: AuthService,
    protected pagesToNavigateService: PagesToNavigateService,
  ) {
    
    super(loadingController, router, storageService, alertController, authService, pagesToNavigateService)
    this.countFinger = localStorage.getItem("fingerCount");
    this.countFinger = Number(this.countFinger);
    console.log("countFinger", this.countFinger);

    this.data = [];


  }

  getConfig() {
    this.bidService.config().subscribe((s: [any]) => {
      s.forEach(data => {
        switch (data.parameter) {

          case 'VENTA-A-SI-MISMO':
            this.ventaAsiMismo = Boolean(data.value);

            this.storage.saveToStorage('skipFingerValidationAgent', data.value).then();

            break;

          case 'FACE-RATIO':
            console.log('FACE-RATIO');
            this.storage.saveToStorage('faceRatio', data.value).then();
            break;

        }
      });
    });
  }

  ngOnInit() {

    this.getConfig();
    console.log('getValuesStorge');
    this.getValuesStorge().then();
    console.log('response getValuesStorgegetValuesStorge');

    this.enrollPage = Boolean(this.route.snapshot.paramMap.get('enroll'));
    this.login = Boolean(this.route.snapshot.paramMap.get('login'));

    if (this.enrollPage) {
      console.log('--------');
      console.log(this.enrollPage);
      this.fingerSelectionComponent.recharge = true;
      this.fingerSelectionComponent.updateSelection();
    }

    this.coppelRoute = this.router.url === '/coppel';
    this.id = this.route.snapshot.queryParamMap.get('sessionId');
    this.action = this.route.snapshot.queryParamMap.get('action');
    this.callbackURL = this.route.snapshot.queryParamMap.get('callbackURL');

    function getUser() {
      // tslint:disable-next-line:no-console
      console.log('User rendering');
      let user = 'dealer web';
      if (user === null) {
        user = prompt('Please enter a name.');
        if (user === null || user === '') {
          alert('A name is required');
          getUser();
        } else {
          localStorage.setItem('lu', user);
        }
      }
    }

    getUser();


    if (this.action) {

      setTimeout(() => {

        if (this.action === 'capture') {
          this.capture();
        } else if (this.action === 'enroll') {
          this.enroll();
        } else if (this.action === 'verify') {
          this.verify();
        } else {
          alert('Invalid action....');
        }

      }, 150);

    }
  }

  async getValuesStorge() {


    this.type = await this.storage.getStorageSync('type');
    console.log(this.type);
    this.speakerAgent = await this.storage.getStorageSync('speakerUser');
    console.log(this.speakerAgent);
    this.speaker = await this.storage.getStorageSync('speaker');
    console.log(this.speaker);

    this.operationId = await this.storage.getStorageSync('originalOperationId');
    console.log(this.operationId);

    if (this.operationId === null) {
      this.operationId = await this.storage.getStorageSync('operationID');
      console.log(this.operationId);
    }


  }


  runTransaction(transaction: TransactionMode) {


    this.countFinger++;
    console.log("countFinger", this.countFinger);
    localStorage.setItem("fingerCount", String(this.countFinger));

    this.fingerSelectionComponent.updateSelection();
    const selection = this.contextMenuSelection.selection;

    console.log(selection.uiSelect);
    let pdx: any;
    const options: SdkOptionsType = {

      localization: {
        en: {
          FEEDBACK_RETRY: 'Algo es extraño, cambia de ubicación',
          FEEDBACK_SEARCHING: 'Buscando...',
          FEEDBACK_INSIDE_GUIDE: 'Estar dentro de la guía',
          FEEDBACK_PLEASE_HOLD: 'Por favor sostenga',
          FEEDBACK_PLEASE_HOLD_FLASH: 'Por favor, mantén presionado para flash',
          FEEDBACK_PLEASE_MOVE: 'Mueva los dedos ligeramente, mejore el enfoque',
          FEEDBACK_PLEASE_MOVE_2: 'Espera el enfoque',
          FEEDBACK_PLEASE_MOVE_IOS_2: 'Vuelve a colocar los dedos <br> para mejorar el enfoque',
          FEEDBACK_NO_FINGERS: 'Buscando mano {0}',
          FEEDBACK_STABLE: 'Por favor sea estable',
          FEEDBACK_HAND_FAR: 'Por favor acerca la mano',
          FEEDBACK_HAND_CLOSE: 'Mueva la mano más lejos',
          FEEDBACK_CAMERA_ACQUIRING_FAILED: 'No se puede adquirir la cámara, permitir el permiso o reintentar la captura',
          FEEDBACK_INITIALIZATION: 'Inicializando ...',
          FEEDBACK_NEXT_DETECTION: '¿Pasar a la siguiente mano?',
          FEEDBACK_ORIENTATION_NOT_SUPPORTED: 'Solo se admite el modo Retrato',
          FEEDBACK_CAPTURING: 'Capturando',
          FEEDBACK_CAPTURED: 'Capturado',
          FEEDBACK_BLURRY: 'Calidad borrosa, reintentar captura',
          FEEDBACK_BLURRY_NO_FLASH: 'La iluminación no era la adecuada. Vuelva a intentarlo en un lugar más brillante',
          FEEDBACK_RETRY_QUALITY: 'Mala calidad, reintentar captura',
          FEEDBACK_RETRY_QUALITY_NO_FLASH: 'La iluminación no era la adecuada. Vuelva a intentarlo en una ubicación mejor.',
          FEEDBACK_RETRY_ERROR: 'Mala calidad, reintentar captura',
          FEEDBACK_FINGER_QUALITY: 'Calidad de los dedos, Reintentar captura',
          FEEDBACK_LICENCE_INVALID: 'Licencia no válida !!',
          FEEDBACK_DIALOG_CLOSED: '',
          FEEDBACK_CAPTURE_TIMEOUT: 'No se detectó ninguna mano, ¿volver a intentarlo?',
          FEEDBACK_PROCESSING: 'Procesando..',
          FEEDBACK_BUTTON_CLOSE: 'Cerrar',
          FEEDBACK_BUTTON_RETRY: 'Reintentar',
          FEEDBACK_TRAINING_BUTTON_NEXT: 'Siguiente',
          FEEDBACK_TRAINING_LABEL: 'No volver a mostrar',
          FEEDBACK_NO_FLASH: 'Asegúrate de estar en un lugar luminoso.',
          FEEDBACK_TRAINING_DIALOG_CLOSED: 'Diálogo de formación, salido',
          FEEDBACK_DETECTION_ERROR: 'Ocurrió un error de detección',
          FEEDBACK_CHANGE_LOCATION: 'Cambiar de ubicación para mejorar el enfoque',
          FEEDBACK_CHANGE_LOCATION_IOS: 'Cambiar de ubicación, con mejor luz',
          ERROR_BROWSER_NOT_SUPPORTED: 'El navegador no es compatible. Actualice a la última versión del navegador.',
          ERROR_URL_NOT_SUPPORTED: 'URL no compatible, SDK requiere que la URL sea https o que el nombre de host sea "localhost"',
          ERROR_WEBRTC_NOT_SUPPORTED: 'Webrtc no soportado',
          ERROR_DETECTION_CANCELLED: 'Siguiente detección cancelada',
          ERROR_MODEL_FAIL: 'Error en la detección del modelo',
          ERROR_INTERNAL_SERVER: 'Error de servidor interno',
          ERROR_REQUEST_EXPIRED: 'La solicitud actual ha caducado, inténtalo de nuevo.',
          ERROR_DECRYPTION_FAILED: 'Solicitar error de integridad',
          BUTTON: {
            OK: 'Aceptar',
            CANCEL: 'Cancelar'
          },
          HAND: {
            LEFT: 'Izquierda',
            RIGHT: 'Derecha'
          }
        }
      },
      base64EncodingFlag: Base64.NO_WRAP,
      enableAS: selection.enableAS,
      asThreshold: selection.asThresold,
      calculateNFIQ: selection.calculateNfiq,
      requiredTemplates: [Template.WSQ],
      wsqCompression: selection.compression,
      showCaptureTraining: selection.showCaptureTraining,
      captureTimeout: 30000,
      showOrientationDialog: true,
      uiSelect: selection.uiSelect,
      showNextHandSelection: false,
      backend: selection.backend,
      debug: true,
      urls: { modelURL: `${this.urlIdentify}/api/v1/model` },
      transaction: {
        type: transaction
      },
      events: {
        onQualityCheckStart() {
          pdx = new ProgressDialog('Processing...', true);
        },
        onNoFlashDetected() {
          alert('Browser doesn\'t support flash, please be in good lighting for an optimal capture');
        },
        onQualityCheckComplete() {

          setTimeout(() => {
            if (pdx) {
              pdx.hide();
            }
          }, 10);
        }
      },
      detectionModes: this.fingerSelectionHelper.fingers.map((finger) => {
        console.log('finger');
        console.log(finger);
        return finger;
      })
    };



    if (selection.uiSelect === AppUI.IMAGE) {
      options.graphics = {
        FINGERS_LEFT_HAND: selection.uiLeft,
        FINGERS_RIGHT_HAND: selection.uiRight,
        FINGER_LEFT_THUMB: selection.uiThumb,
        FINGER_RIGHT_THUMB: selection.uiThumb
      };

      console.log('opppptions');
      console.log(options.graphics);
    }

    if (transaction === TransactionMode.VERIFY) {
      if (!options.transaction) {
        options.transaction = {};
      }
      console.log('SDK VERIFY...');
      options.transaction.id = localStorage.getItem('transactionId');
    }

    const fingerSDK = new FingerSDK(options);

    fingerSDK.onInit = () => {
      if (window.parent) {
        // tslint:disable-next-line:no-console
        console.log('SDK Loaded...');
        console.log('Lanzando componente F...');
        window.parent.postMessage('IdentySDKLoaded', '*');
      }

      fingerSDK.capture()
        .then((blob: Blob) => {
          return this.postData(fingerSDK, blob, transaction);
        }).catch((err) => {
            console.log("err-.........",err);
          if (err instanceof LocalizationMessage) {
            if (err.code !== 202 && err.code !== 501) {
              alert(err.getLocalizedString());
            } else {
              this.showTimeout(err, fingerSDK, transaction);
            }
          }

        });

    };


    fingerSDK.initialize().catch((err) => {

      if (err instanceof LocalizationMessage) {

        if (err.code === 100 || err.code === 102 || err.code === 500 || err.code === 600) {
          alert(err.getLocalizedString());
        }
      }

      // tslint:disable-next-line:no-console
      console.log(err);

    });
  }

  capture() {
    this.runTransaction(TransactionMode.CAPTURE);
    console.log("TransactionMode.CAPTURE");


  }

  enroll() {
    this.runTransaction(TransactionMode.ENROLL);
    console.log("TransactionMode.ENROLL");
  }

  verify() {
    this.runTransaction(TransactionMode.VERIFY);
    console.log("TransactionMode.VERIFY");
  }


  saveFingers(dataFinger: string) {

  }

  postData(sdk: FingerSDK, capresult: Blob, action: TransactionMode) {

    // tslint:disable-next-line:no-console
    console.log("postDataFinger");


    this.loadingController.getTop().then(hasLoading => {
      this.loadingController.create({
        spinner: 'circular',
        translucent: true
      }).then(loading => loading.present());
    });

    return new Promise((resolve => {

      const fd = new FormData();
      fd.append('file', capresult, `bdata`);

      ajax({
        url: `${this.urlIdentify}/api/v1/process?ts=${new Date().getTime()}`,
        contentType: false,
        processData: false,
        method: 'POST',
        dataType: 'JSON',
        data: fd,
        headers: {
          'X-DEBUG': sessionStorage.getItem('lu') || localStorage.getItem('lu')
        }
      }).done((response: any) => {

        console.log("response T: ...", response);
        const clientResponse = { transaction_id: response.id, code: response.code, feedback_code: response.message };

        let idT = clientResponse.transaction_id.toString();
        console.log("idT.....", idT);

        let userId;
        this.storageService.getStorage('userId').then((savedUserId: any) => {
          userId = savedUserId.value;
          console.log("userId", userId);
          let tokenJava;
          this.storageService.getStorage('TOKENJAVA').then((savedToken: any) => {
            this.storageService.getStorage('originalOperationId').then((savedOriginalOp) => {
              let opId = savedOriginalOp.value;
              if (opId === null) {
                this.storageService.getStorage('operationID').then((operationId) => {
                  opId = operationId.value;
                  tokenJava = savedToken.value;
                  console.log("tokenJava ", tokenJava);
                  this.bidService.contadorT(idT, opId, userId, tokenJava, "FINGER", this.buildMetadata()).subscribe((data) => {
                    console.log("contadorT: ", data);
                  }, error => {
                  });
                });
              } else {
                tokenJava = savedToken.value;
                console.log("tokenJava ", tokenJava);
                this.bidService.contadorT(idT, opId, userId, tokenJava, "FINGER", this.buildMetadata()).subscribe((data) => {
                  console.log("contadorT: ", data);
                }, error => {
                });

              }
            })
          });
        });


        if (action === TransactionMode.ENROLL) {
          localStorage.setItem('transactionId', clientResponse.transaction_id.toString());
        }

        if (this.contextMenuSelection.selection.download) {
          new ZipModule().package(response, this.coppelRoute).then((zipv) => {
            saveAs(zipv, `finger-templates-${new Date().getTime()}.zip`);
          });
        }

        // tslint:disable-next-line:no-console
        console.log('*****************************TID**********************************');
        // tslint:disable-next-line:no-console
        console.log(clientResponse.transaction_id.toString());
        // tslint:disable-next-line:no-console
        console.log('*****************************TID**********************************');
        const f = [];
        const hands = ['LEFT', 'RIGHT'];
        const fingers = ['INDEX', 'MIDDLE', 'RING', 'LITTLE', 'THUMB'];
        for (const hand of hands) {
          for (const finger of fingers) {
            const val = `(${hand},${finger})`;
            if (response.data.hasOwnProperty(val)) {
              const op = response.data[val];

              f.push({
                image: 'data:image/wsq;base64,' + op.templates.WSQ,
                hand: op.hand,
                finger: op.finger,
                nfiq: op.nfiq,
                score: op.score,
                base64: op.templates.WSQ,
              });
            }
          }

        }
        this.storage.saveToStorage('ENROLLFINGER', JSON.stringify(f)).then();


        if (this.login) {
          this.verifyFinger(f);
        } else {
          if (this.ventaAsiMismo) {
            this.verifyClient(f);
          } else {
            this.identifyAgent(f);
          }

        }


        // @ts-ignore
        resolve(null);

      }).fail((err) => {
        console.log("err-------",err);
        
        let userId;
        let idT = "";
        this.storageService.getStorage('userId').then((op: any) => {
          userId = op.value;
          console.log("userId", userId);
          let tokenJava;
          this.storageService.getStorage('TOKENJAVA').then((op: any) => {
            this.storageService.getStorage('originalOperationId').then((op) => {
              let opId = op.value;
              if (opId === null) {
                this.storageService.getStorage('operationID').then((op) => {
                  opId = op.value;
                  tokenJava = op.value;
                  console.log("tokenJava ", tokenJava);
                  this.bidService.contadorT(idT, opId, userId, tokenJava, "FINGER", this.buildMetadata()).subscribe((data) => {
                    console.log("contadorT: ", data);
                  }, error => {
                  });
                });
              } else {
                tokenJava = op.value;
                console.log("tokenJava ", tokenJava);
                this.bidService.contadorT(idT, opId, userId, tokenJava, "FINGER", this.buildMetadata()).subscribe((data) => {
                  console.log("contadorT: ", data);
                }, error => {
                });

              }
            })
          });
        });

        this.loadingController.dismiss().then();
        let message = err.responseJSON.message;
        this.alertService.presentAlert('Error', 'Favor de reintentar').then();
        if (!sdk.hasFlash()) {
          if (message === 'FEEDBACK_BLURRY') {
            message = 'FEEDBACK_BLURRY_NO_FLASH';
          } else if (message === 'FEEDBACK_RETRY_QUALITY') {
            message = 'FEEDBACK_RETRY_QUALITY_NO_FLASH';
          }
        }
      });

    }));

  }

  verifyClient(f) {

    let typeUser = 1;
    if (this.type !== 'register') {
      typeUser = 2;
    }
    console.log('Verificando Cliente');
    const reqFinger = {
      operationId: this.operationId,
      data: {
        userType: typeUser,
        rightindex: f[4].base64,
        rightmiddle: f[5].base64,
        rightring: f[6].base64,
        rightlittle: f[7].base64,
        leftindex: f[0].base64,
        leftmiddle: f[1].base64,
        leftring: f[2].base64,
        leftlittle: f[3].base64,
      }
    };

    console.log(reqFinger);
    this.bidService.identifyVerify(reqFinger).subscribe(async (data: any) => {

      console.log('response verifyClient identify');
      console.log(data);
      if (data.message === 'Usuario encontrado') {
        this.loadingController.dismiss().then();
        let confirm;
        if (this.type === 'register') {
          confirm = await this.alertService.presentAlertConfirm('Error', 'El agente ya se encuentra enrolado').then();
        } else {
          if (typeUser === 2) {
            confirm = await this.alertService.presentAlertConfirm('Error', 'El cliente ya se  encuentra enrolado').then();

          } else {
            confirm = await this.alertService.presentAlertConfirm('Error', 'El agente no puede venderse a si mismo').then();

          }
        }
        if (confirm) {
          if (this.type === 'register') {
            this.storage.saveToStorage('personIdFound', data.person.id).then();
            this.storage.saveToStorage('operationID', data.operation.id).then();
            this.storage.saveToStorage('personID', data.person.id).then();
            this.storage.saveToStorage('speaker', data.person.code).then();
            this.findRecoverEnroll(data.operation.id);

          } else {
            this.storage.saveToStorage('personIdFound', data.person.id).then();
            this.storage.saveToStorage('operationID', data.operation.id).then();
            this.storage.saveToStorage('personID', data.person.id).then();
            this.storage.saveToStorage('speaker', data.person.code).then();
            this.findRecoverEnroll(data.operation.id);

          }
        }

      } else {
        this.loadingController.dismiss();
        this.router.navigateByUrl('/correo-electronico-contrato');
      }

    }, error => {
      console.log('ERROOOR');
      console.log(error);
      this.loadingController.dismiss();
      this.router.navigateByUrl('/correo-electronico-contrato');
    });

  }

  findRecoverEnroll(opId) {


    console.log('findRecoverEnroll');

    this.loadingController.getTop().then(hasLoading => {
      this.loadingController.create({
        spinner: 'circular',
        translucent: true
      }).then(loading => loading.present());
    });
    this.bidService.recoverEnroll(opId).subscribe((dataRecover: any) => {

      console.log(dataRecover);
      console.log(dataRecover.activityValue);
      switch (dataRecover.activityValue) {
        case 'NOTICE_OF_PRIVACY_ACCEPTED':
        case 'EMAIL_OK':
          this.router.navigateByUrl('/dashboard/face');
          break;
        case 'BIO_FACE_CAPTURED':
          this.router.navigateByUrl('/seleccionar-doc');
          break;

        case 'ID_INE_CAPTURED':
        case 'ID_OTHER_CAPTURED':
          console.log(dataRecover.tipoDocumento);
          if (dataRecover.tipoDocumento === 'PASSPORT') {
            this.router.navigate(['/dashboard/ine', { type: 'Pasaporte Mexicano' }]);
          }

          if (dataRecover.tipoDocumento === 'IDOF') {
            this.router.navigate(['/dashboard/ine', { type: 'Identificación INE' }]);
          }

          if (dataRecover.tipoDocumento === 'IDCEDP') {
            this.router.navigate(['/dashboard/ine', { type: 'Cedula Profesional' }]);
          }

          if (dataRecover.tipoDocumento === 'FM3') {
            this.router.navigate(['/dashboard/ine', { type: 'Forma Migratoria' }]);
          }
          break;

        case 'ID_INE_VALIDATION':
        case 'ID_OK':
        case 'ID_INE_CONSENT_NOTICE_SAVED':
          if (dataRecover.tipoDocumento === 'PASSPORT') {
            this.storage.saveToStorage('OCR', JSON.stringify(dataRecover.ocr.normalDocument)).then(() => {
              this.router.navigate(['/pasaporte']);
            });
          }

          if (dataRecover.tipoDocumento === 'IDOF') {

            this.storage.saveToStorage('OCR', JSON.stringify(dataRecover.ocr.normalDocument)).then(() => {
              this.router.navigate(['/ine-data']);
            });
          }

          if (dataRecover.tipoDocumento === 'IDCEDP') {
            this.storage.saveToStorage('OCR', JSON.stringify(dataRecover.ocr.normalDocument)).then(() => {
              this.router.navigate(['/cedula-profesional']);
            });
          }

          if (dataRecover.tipoDocumento === 'FM3') {
            this.storage.saveToStorage('OCR', JSON.stringify(dataRecover.ocr.normalDocument)).then(() => {
              this.router.navigate(['/forma-migratoria']);
            });
          }

          break;

        case 'CUSTOMER_NEW_ACCEPTED':
          this.router.navigateByUrl('/expediente');
          break;
      }
      this.loadingController.dismiss();
    }, error => {
      this.loadingController.dismiss();
    });

  }

  identifyAgent(f) {

    console.log(this.speakerAgent);
    const reqFinger = {
      operationId: this.operationId,
      data: {
        speaker: this.speakerAgent,
        rightindex: f[4].base64,
        rightmiddle: f[5].base64,
        rightring: f[6].base64,
        rightlittle: f[7].base64,
        leftindex: f[0].base64,
        leftmiddle: f[1].base64,
        leftring: f[2].base64,
        leftlittle: f[3].base64,
      }
    };
    this.bidService.fingerVerify(reqFinger).subscribe(async (data: any) => {
      console.log('asdsAgenteadasd');
      if (data.error === undefined) {
        this.loadingController.dismiss().then();
        const confirm = await this.alertService.presentAlertConfirm('Error', 'El agente no puede venderse a si mismo').then();
        if (this.type === 'register') {
          this.router.navigateByUrl('/register-user');

        } else {
          this.router.navigateByUrl('/dashboard');

        }
      } else {
        this.verifyClient(f);
      }
    }, () => {
      this.verifyClient(f);
    });
  }


  identify(f) {
    console.log('clientttt identify');
    let userType = 1;
    if (this.type === 'register') {
      userType = 1;
    }
    const reqFinger = {
      operationId: this.operationId,
      data: {
        userType,
        rightindex: f[4].base64,
        rightmiddle: f[5].base64,
        rightring: f[6].base64,
        rightlittle: f[7].base64,
        leftindex: f[0].base64,
        leftmiddle: f[1].base64,
        leftring: f[2].base64,
        leftlittle: f[3].base64,
      }
    };
    this.bidService.identifyVerify(reqFinger).subscribe(async (data: any) => {
      if (data.message === 'Usuario encontrado') {
        this.loadingController.dismiss().then();
        const confirm = await this.alertService.presentAlertConfirm('Error', 'El agente no puede venderse a si mismo').then();
        if (confirm) {
          if (this.type === 'register') {
            this.router.navigateByUrl('/register-user');

          } else {
            this.router.navigateByUrl('/dashboard');

          }
        }

      } else {
        this.loadingController.dismiss();
        this.router.navigateByUrl('/correo-electronico-contrato');
      }

    }, error => {
      console.log('ERROOOR');
      console.log(error);
      this.loadingController.dismiss();
      this.router.navigateByUrl('/correo-electronico-contrato');
    });
  }

  verifyFinger(f) {
    if (this.enrollPage) {
      this.storage.saveToStorage('ENROLLFINGER', JSON.stringify(f)).then();
      this.loadingController.dismiss();
      this.router.navigateByUrl('/correo-electronico-contrato');

    } else {
      console.log('verriifyyyy');
      const reqFinger = {
        operationId: this.operationId,
        data: {
          speaker: this.speaker,
          rightindex: f[4].base64,
          rightmiddle: f[5].base64,
          rightring: f[6].base64,
          rightlittle: f[7].base64,
          leftindex: f[0].base64,
          leftmiddle: f[1].base64,
          leftring: f[2].base64,
          leftlittle: f[3].base64,
        }
      };
      this.bidService.fingerVerify(reqFinger).subscribe((data: any) => {
        if (data.error === undefined) {
          this.loadingController.dismiss();
          this.router.navigateByUrl('/dashboard');
        } else {
          this.loadingController.dismiss();
          this.alertService.presentToast('danger', 'RFC y huellas  invalidas');
        }
      }, () => {
        this.loadingController.dismiss();
        this.alertService.presentToast('danger', 'RFC y huellas  invalidas');
      });
    }
  }

  showTimeout(err, sdk, action) {
    const clientResponse = { code: err.code, feedback_code: err.message };
    if (err.code !== 202) {
      const dialog = new TransactionCompleteDialog(clientResponse, sdk.getOptions(), sdk.localization);
      dialog.render();
      dialog.retryClicked = () => {
        if (action === TransactionMode.ENROLL) {
          this.enroll();
        } else if (action === TransactionMode.VERIFY) {
          this.verify();
        } else {
          this.capture();
        }
      };
    }

  }

}
